import React from 'react';
import {IconType} from '../../icons';

export const Success: IconType = ({height = 160, width = 160, ...props}) => {
  return (
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 160 160"
      {...props}
    >
      <circle
        cx="80.5"
        cy="80.5"
        r="47.5"
        stroke="#001F5C"
        strokeWidth="1.79614"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.9843 78.1138C54.6688 78.1138 53.4067 78.6344 52.4738 79.5606L52.4731 79.5616C51.5302 80.496 51 81.768 51 83.0941C51 84.4209 51.5302 85.6929 52.4731 86.6266L67.4123 101.553C68.3451 102.48 69.6072 103 70.9228 103C72.2391 103 73.5004 102.48 74.4341 101.553L106.802 69.2124C107.9 67.9313 108.275 66.1821 107.795 64.5645C107.317 62.9477 106.051 61.6824 104.432 61.2043C102.814 60.7262 101.063 61.0994 99.7811 62.1964L70.9485 91.0046L59.4956 79.5606C58.5619 78.6344 57.3006 78.1138 55.9843 78.1138Z"
        fill="#3164FA"
      />
    </svg>
  );
};
